import React from 'react';
import { FacebookIcon, YoutubeIcon, PhoneIcon, MapPinIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full" style={{
    backgroundColor: '#0f2318'
  }} aria-label="Site footer" data-id="element-71">
      {/* Gold top border */}
      <div className="w-full h-1" style={{
      backgroundColor: '#c8a84b'
    }} data-id="element-72" />

      <div className="max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16" data-id="element-73">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-74">
          {/* Brand column */}
          <div className="lg:col-span-1" data-id="element-75">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/FentonLakes-logo.png" alt="Fenton Lakes Sportsman's Club" className="block h-14 w-auto mb-4" data-id="element-76" />
            <p className="text-sm leading-relaxed mb-5" style={{
            color: '#7a9a8a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-77">
              Serving our community by protecting natural resources and
              supporting fellow sportsmen since 1953.
            </p>
            <div className="flex gap-3" data-id="element-78">
              <a href="https://www.facebook.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-9 h-9 rounded-lg flex items-center justify-center transition-all hover:opacity-80" style={{
              backgroundColor: 'rgba(255,255,255,0.08)',
              color: '#a0b8a8'
            }} data-id="element-79">
                <FacebookIcon size={16} data-id="element-80" />
              </a>
              <a href="https://www.youtube.com/FentonLakesSportsmansClub" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="w-9 h-9 rounded-lg flex items-center justify-center transition-all hover:opacity-80" style={{
              backgroundColor: 'rgba(255,255,255,0.08)',
              color: '#a0b8a8'
            }} data-id="element-81">
                <YoutubeIcon size={16} data-id="element-82" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-83">
            <h3 className="text-sm font-bold uppercase tracking-wider mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#c8a84b'
          }} data-id="element-84">
              Quick Links
            </h3>
            <ul className="space-y-2.5" data-id="element-85">
              {[{
              label: 'Home',
              href: '/'
            }, {
              label: 'Calendar',
              href: '/Calendar.html'
            }, {
              label: 'Clubhouse Rental',
              href: '/ClubhouseRental.html'
            }, {
              label: 'Range Rules',
              href: '/RangeRules.html'
            }, {
              label: 'Newsletter',
              href: '/FLSCNewsletter.html'
            }, {
              label: 'Contact Us',
              href: '/ContactUs.html'
            }, {
              label: 'Photo Tour',
              href: '/PhotoTour.html'
            }, {
              label: 'Privacy Policy',
              href: '/PrivacyPolicy.html'
            }].map(({
              label,
              href
            }) => <li key={href} data-id="element-86">
                  <a href={href} className="text-sm transition-colors hover:opacity-80" style={{
                color: '#7a9a8a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-87">
                    {label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Activities */}
          <div data-id="element-88">
            <h3 className="text-sm font-bold uppercase tracking-wider mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#c8a84b'
          }} data-id="element-89">
              Activities
            </h3>
            <ul className="space-y-2.5" data-id="element-90">
              {[{
              label: 'Sporting Clays',
              href: '/SportingClays.html'
            }, {
              label: 'Cowboy Action Shooting',
              href: '/SASS.html'
            }, {
              label: 'Steel Challenge',
              href: '/SteelChallenge.html'
            }, {
              label: '3-D Archery',
              href: '/3DArchery.html'
            }, {
              label: 'Jr. Rifle',
              href: '/JrRifle.htm'
            }, {
              label: 'PPC Shooting',
              href: '/PPCShooting.html'
            }, {
              label: 'Bowling Pin Shoots',
              href: '/BowlingPinShoots.html'
            }].map(({
              label,
              href
            }) => <li key={href} data-id="element-91">
                  <a href={href} className="text-sm transition-colors hover:opacity-80" style={{
                color: '#7a9a8a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-92">
                    {label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-93">
            <h3 className="text-sm font-bold uppercase tracking-wider mb-4" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#c8a84b'
          }} data-id="element-94">
              Contact
            </h3>
            <div className="space-y-4" data-id="element-95">
              <div className="flex items-start gap-3" data-id="element-96">
                <MapPinIcon size={15} className="flex-shrink-0 mt-0.5" style={{
                color: '#4a7c59'
              }} data-id="element-97" />
                <p className="text-sm" style={{
                color: '#7a9a8a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-98">
                  1140 Butcher Rd
                  <br data-id="element-99" />
                  Fenton, MI 48430-1232
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-100">
                <PhoneIcon size={15} style={{
                color: '#4a7c59'
              }} data-id="element-101" />
                <a href="tel:8106297964" className="text-sm transition-colors hover:opacity-80" style={{
                color: '#7a9a8a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-102">
                  (810) 629-7964
                </a>
              </div>
              <div className="flex items-center gap-3" data-id="element-103">
                <MailIcon size={15} style={{
                color: '#4a7c59'
              }} data-id="element-104" />
                <a href="mailto:flsportsmansclub@gmail.com" className="text-sm transition-colors hover:opacity-80" style={{
                color: '#7a9a8a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-105">
                  flsportsmansclub@gmail.com
                </a>
              </div>
            </div>

            {/* Emblem */}
            <div className="mt-6" data-id="element-106">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/FLSC%20NEW%20ALPHA%20Outline.png167x167.png" alt="FLSC Emblem" className="block w-16 h-16 object-contain opacity-60" data-id="element-107" />
            </div>

            {/* Apply CTA */}
            <div className="mt-5" data-id="element-108">
              <a href="/Apply-For-Membership" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
              backgroundColor: '#c8a84b',
              color: '#1a1a1a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-109">
                Apply for Membership
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4" style={{
        borderTop: '1px solid rgba(255,255,255,0.08)'
      }} data-id="element-110">
          <p className="text-xs" style={{
          color: '#4a6a5a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-111">
            © {new Date().getFullYear()} Fenton Lakes Sportsman's Club. All
            rights reserved.
          </p>
          <div className="flex gap-4" data-id="element-112">
            <a href="/PrivacyPolicy.html" className="text-xs transition-colors hover:opacity-80" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-113">
              Privacy Policy
            </a>
            <a href="/RangeRules.html" className="text-xs transition-colors hover:opacity-80" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-114">
              Range Rules
            </a>
            <a href="https://my-store-c0b81b.creator-spring.com" target="_blank" rel="noopener noreferrer" className="text-xs transition-colors hover:opacity-80" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-115">
              Store
            </a>
          </div>
        </div>
      </div>
    </footer>;
}